<template>
    <div class="activity-detail">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 16px;">
            惊喜盲盒（{{ activityInfo.code }}）
        </div>
        <div class="flex-between">

            <div class="formTitle">活动信息</div>
            <el-button
                @click="$utils.copyText(`pages/activity/activity?activityId=${activityInfo.id}`)">复制活动链接</el-button>
        </div>
        <!-- 活动信息 -->
        <el-descriptions :column="3" border>
            <el-descriptions-item label="活动标题">{{ activityInfo.name }}</el-descriptions-item>
            <el-descriptions-item label="活动状态">
                <el-tag :type="activityInfo.status | filterConst('ACTIVITYSTATUS', 'tag')">{{ activityInfo.status |
                    filterConst("ACTIVITYSTATUS") }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="活动时间">{{ activityInfo.startDate | filterTime('YYYY-MM-DD') }} - {{
                activityInfo.endDate | filterTime('YYYY-MM-DD') }}</el-descriptions-item>
            <el-descriptions-item label="机构名称">{{ activityInfo.organizationName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="活动奖励">随机掉落{{ activityInfo.issuedNum }}张优惠券</el-descriptions-item>
            <el-descriptions-item label="参与次数">活动时间内可参与1次</el-descriptions-item>
            <el-descriptions-item label="活动奖池" span="2">
                <div v-for="(item, idx) in activityInfo.couponPool" :key="idx">
                    {{ item.couponName }}×{{ item.totalNum }}张，剩余{{ item.remainingNum }}张
                </div>
            </el-descriptions-item>
            <el-descriptions-item label="活动说明">
                <div class="activity-explanation">{{ activityInfo.explanation || '-' }}</div>
            </el-descriptions-item>
        </el-descriptions>

        <!-- 活动数据 -->
        <div class="formTitle" style="margin-bottom: 0;">活动数据</div>
        <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :refreshShow="false"
            style="height: calc(100vh - 304px);">
            <template slot-scope="{ item, row }">
                <template v-if="item.prop === 'status'">
                    <el-tag v-if="row.status == 1" type="info">未使用</el-tag>
                    <el-tag v-if="row.status == 2" type="success">已使用</el-tag>
                    <el-tag v-if="row.status == 3" type="info">已失效</el-tag>
                </template>
                <template v-else-if="['created', 'expirationDay', 'usageTime'].includes(item.prop)">
                    {{ row[item.prop] | filterTime('YYYY-MM-DD HH:mm:SS') }}
                </template>
                <template v-else>
                    {{ row[item.prop] || '-' }}
                </template>

            </template>
        </custom-table>
    </div>
</template>

<script>
/**
 * 活动详情页面
 * @module ActivityDetail
 */
export default {
    name: 'ActivityDetail',
    props: {
        activityId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            // 活动信息
            activityInfo: {
                title: '暑期惊喜礼盒',
                status: '进行中',
                progress: '进行中',
                time: '2025/05/01～2025/05/30',
                org: 'xxx',
                prizePool: [
                    '优惠券名称x100张，剩余50张',
                    '优惠券名称x100张，剩余50张',
                    '优惠券名称x100张，剩余50张'
                ],
                prize: '随机掉落1张优惠券',
                count: '活动时间内可参与1次',
                desc: '-'
            },
            // 配置项
            customOptions: {
                // 请求的列表url
                url: "/api/v1/manage/activity/couponData",
                // 请求的参数列表
                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                    activityId: this.activityId
                },
            },
            // 表头
            columns: [
                { prop: "customerPhone", label: "用户手机", width: 100 },
                { prop: "couponName", label: "领取的优惠券", minWidth: 120 },
                { prop: "status", label: "使用状态", width: 80 },
                { prop: "created", label: "领取时间", width: 140 },
                { prop: "expirationDay", label: "失效时间", width: 140 },
                { prop: "usageTime", label: "使用时间", width: 140 },
            ],
        }
    },
    computed: {
    },
    created() {
        this.getActivityInfo()
    },
    methods: {
        async getActivityInfo() {
            const { code, data } = await this.$axios.get(`/api/v1/manage/activity/${this.activityId}`)
            if (code == 1) {
                this.activityInfo = data
            }
        }
    }
}
</script>

<style lang="less" scoped>
.activity-detail {
    .activity-explanation {
        // 多行省略
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
    }
    :deep(.el-descriptions-item__label) {
        width: 80px;
        color: #606266;
        vertical-align: top;
    }

    :deep(.el-descriptions-item__content) {
        width: 180px;
        vertical-align: top;
    }
}
</style>